<template>
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <b-link class="brand-logo">
         <img :src="logo_fondo_claro" alt="Logo" />
      </b-link>
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          {{ $t('No estas autorizado!') }} 🔐
        </h2>
        <p class="mb-2">
          {{ $t('No tienes permiso para acceder a esta página. Vuelve a casa!') }}
        </p>
        <b-button
          variant="primary"
          class="mb-1 btn-sm-block"
          @click="loginRoute()"
        >{{ $t('De vuelta a casa') }}</b-button>
        <b-img
          fluid
          :src="imgUrl"
          alt="Not authorized page"
        />
      </div>
    </div>
  </div>
</template>

<script setup>


import downImg from '@/assets/images/pages/not-authorized.svg'
import downImgDark from '@/assets/images/pages/not-authorized-dark.svg'

import logo_fondo_claro from 'images/logos/logo_fondo_claro.svg'

import router from '@/router';
import useAppConfigStore from '@/store/app-config'
import useUsuarioStore from '@/store/usuario';


const app_config_store = useAppConfigStore();
const usuario_store = useUsuarioStore();

const { layout } = storeToRefs(app_config_store);
const { usuario } = storeToRefs(usuario_store);

const skin = computed(() => layout.value.skin)

const loginRoute = () => {

  if (usuario.value.id) {
    router.push({ name: 'home' })
  } else {
    router.push({ name: 'login' })
  }
}

const imgUrl = computed(() => layout.value.skin === 'dark' ? downImgDark : downImg);

</script>

<style lang="scss">
@import '@/assets/scss/vue/pages/page-misc.scss';
</style>
